<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" size="mini"  :inline="true" ref="ruleForm" label-width="100px"
      class="demo-ruleForm">

      <el-form-item label="字典编号" prop="dicCode" required>
        <el-input v-model="ruleForm.dicCode" :disabled="dialogType === 'detail'"></el-input>
      </el-form-item>

      <el-form-item label="字典名称" prop="dicName" required>
        <el-input v-model="ruleForm.dicName" :disabled="dialogType === 'detail'"></el-input>
      </el-form-item>

      <el-form-item label="字典值" prop="dicValue" required>
        <el-input v-model="ruleForm.dicValue" :disabled="dialogType === 'detail'"></el-input>
      </el-form-item>

      <el-form-item label="字典类型" prop="dicType" required>
        <el-input v-model="ruleForm.dicType" :disabled="dialogType === 'detail'"></el-input>
      </el-form-item>

      <el-form-item label="字典说明">
        <el-input v-model="ruleForm.dicExplain" :disabled="dialogType === 'detail'"></el-input>
      </el-form-item>

      <el-form-item label="启用情况" prop="state" required>
        <div style="width:250px;text-align:left;">
          <el-switch v-model="ruleForm.state" active-value="1" inactive-value="0" :disabled="dialogType === 'detail'"></el-switch>
        </div>
      </el-form-item>

      <el-form-item label="备注">
        <el-input type="textarea" v-model="ruleForm.remark1" :disabled="dialogType === 'detail'"></el-input>
      </el-form-item>
      <el-form-item label="无" style="visibility:hidden;">
        <el-input type="textarea"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'MyContent',
  props: {
    ruleForm: {
      type: Object
    },
    dialogType: String
  },
  data() {
    return {
      rules: {
        dicCode: [{
          required: true,
          message: '请输入字典编号',
          trigger: 'blur'
        }],
        dicName: [{
          required: true,
          message: '请输入字典名称',
          trigger: 'blur'
        }],
        dicValue: [{
          required: true,
          message: '请输入字典值',
          trigger: 'blur'
        }],
        dicType: [{
          required: true,
          message: '请输入字典类型',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handelZbCalculationRefid(val) {
      this.ruleForm.zbCalculationRefid = val;
    }
  }
};

</script>
<style lang="scss" scoped>
  .demo-ruleForm {
    margin: 0 auto;
    text-align: center;
    .el-input,
    .el-select,
    .el-cascader {
      width: 250px;
      height: 32px;

      input {
        height: 32px;
      }
    }

    .el-textarea {
      width: 250px;
    }
  }

</style>
